// extracted by mini-css-extract-plugin
export default {"root":"_1HTfL","popover":"_3XaAR","content":"_2iUZh","list":"_6XaYx","list-item":"_30yQn","listItem":"_30yQn"};